import { Component, Output, Input, OnInit, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import { ClienteService } from '../../services/cliente.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from '../../utils/constants';
import { AlertService } from "../../services/alert.service";

@Component({
  selector: 'app-gestiones-patrones',
  templateUrl: './gestiones-patrones.component.html',
  styleUrls: ['./gestiones-patrones.component.scss']
})
export class GestionesPatronesComponent implements OnInit {
  public mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  @Output() selecttab = new EventEmitter<number>();
  @Input() clienteserviceParam: ClienteService;
  @ViewChild('codigopatrono', {static: false}) codigoinput: ElementRef;
  @ViewChild('nombrepatrono', {static: false}) nombreinput: ElementRef;
  patronesForm: FormGroup;
  dataPatronos = [];
  enableRiskCategory = false;

  // bindings extra to client have grater than one chief or grater than one screed.
  patronos = [];
  renglones = [];

  listPatronos = new Map();
  patronoSelected;
  submitAttempt = false;
  autocompleteE = false;
  cargaindicesbool = false;
  clientData: any = {};
  precalificationData: any = {};
  ingresosydeducciones: any = {};
  formatterDecimal = new Intl.NumberFormat("es-GT", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: "decimal",
  });
  mostrarFecha = false;
  constructor(private formBuilder: FormBuilder, 
    private alertService: AlertService,
    private ngxUiLoaderService: NgxUiLoaderService) {
    this.patronesForm = formBuilder.group({
      codigoPatrono: ['', Validators.compose([Validators.pattern(/^\d{4,20}$/)])],
      codigoPatronoSelected: [null],
      nombrePatrono: ['', Validators.compose([Validators.minLength(2), Validators.maxLength(120), Validators.required])],
      codigoCliente: ['', Validators.compose([Validators.pattern(/^\d{4,12}$/), Validators.required])],
      estado: ['', Validators.compose([Validators.required])],
      categoriariesgo: ['', Validators.compose([Validators.required])],
      categoriagasto: ['', Validators.compose([Validators.required])],
      reglon: ['0', Validators.compose([Validators.required])],
      fechaingreso: ['', Validators.compose([
        Validators.pattern(/^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/\-](20|19)\d{2}$/),
        Validators.required]),
      ],
      codigoEmpleado: ['', Validators.compose([Validators.pattern(/^\d{1,20}$/)])],
      empleoanterior: ['N', Validators.compose([Validators.required])],
      fechainicioempleoanterior: ['', Validators.compose([
        Validators.pattern(/^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/\-](20|19)\d{2}$/)]),
      ],
      fechafinempleoanterior: ['', Validators.compose([
        Validators.pattern(/^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/\-](20|19)\d{2}$/)]),
      ],
      salarioBase: ['', Validators.compose([Validators.pattern(/^\d{1,20}$/),Validators.required])],
    });
    setTimeout(() => {
      this.autocompleteIngresos();
      this.autocompleteDataPatrono();
      if (this.precalificationData.segmento === 'E') {
        this.patronesForm.controls.codigoEmpleado.setValidators(Validators.compose([
          Validators.pattern(/^\d{1,20}$/),
          Validators.required,
        ]));
        this.patronesForm.controls.codigoEmpleado.updateValueAndValidity();
      }
    }, 500);
  }

  ngOnInit(): void {
    this.clientData =  this.clienteserviceParam.flowType === 'DEBTOR'
      ? this.clienteserviceParam.datosCliente : this.clienteserviceParam.datosCodeudor;
    this.precalificationData =  this.clienteserviceParam.flowType === 'DEBTOR'
      ? this.clienteserviceParam.datosPrecalificacion : this.clienteserviceParam.datosPrecalificacionCodeudor;
    this.patronos = [];
    if (this.clientData.datosIndice.isMoreChiefs === true) {
      if (this.clientData.datosIndice.patronos
        && this.clientData.datosIndice.patronos.length > 0) {
        const firstPatron = this.clientData.datosIndice.patronos[0];

        this.clientData.datosIndice.patronos.forEach(item => {
          if (item.numeroPatrono === firstPatron.numeroPatrono) {
            this.patronos.unshift(item);
          } else {
            this.patronos.push(item);
          }
        });
      }
      this.autocompleteDataPatrono();
    }

    if (this.precalificationData.datosPatrono != null) {
      this.patronesForm.patchValue(this.precalificationData.datosPatrono);
      this.patronoSelected = this.precalificationData.patronoSelected;
    }

    if (this.precalificationData.segmento === 'E') {
      let index = this.patronoSelected ? this.patronoSelected.position : 0;
      if (this.clientData.datosIndice.clienteDatosIndice && this.clientData.datosIndice.clienteDatosIndice.length > 0) {
        this.mostrarFecha = !this.clientData.datosIndice.clienteDatosIndice[index].fechaIngreso;
      }
    }
    else {
      this.mostrarFecha = true;
    }

    if(this.precalificationData.segmento == "PV") {
      this.patronos = Constants.PATRONOS_PAGO_VOLUNTARIO.filter(i=>i.fuenteIngreso.slice(0, 1)==this.precalificationData.codigoSegmentoRiesgoPagoVoluntario);
      //this.patronesForm.get('codigoPatrono').disable();
      this.patronesForm.get('nombrePatrono').disable();
    }
  }
  
  allowPatron(code, name): void {

    if (name && name.toUpperCase().includes('PAGO POR CAJA')) {
      this.patronesForm.get('codigoPatrono').setValue('');
      this.patronesForm.get('nombrePatrono').setValue('');
      this.patronesForm.get('codigoCliente').setValue('');
      this.patronesForm.get('estado').setValue('');
      this.patronesForm.get('categoriariesgo').setValue('');
      this.patronesForm.get('categoriagasto').setValue('');
      this.showNotification('¡Alerta!', 'El patrono ingresado no aplica a bienestar');
    }
    const findPatron = Constants.NOT_ALLOWED_PATRONS.find(item => item === code);
    if (findPatron) {
      this.patronesForm.get('codigoPatrono').setValue('');
      this.patronesForm.get('nombrePatrono').setValue('');
      this.patronesForm.get('codigoCliente').setValue('');
      this.patronesForm.get('estado').setValue('');
      this.patronesForm.get('categoriariesgo').setValue('');
      this.patronesForm.get('categoriagasto').setValue('');
      this.showNotification('¡Alerta!', 'El patrono ingresado no aplica a bienestar');
    }
  }

  consultaPatrono() {
    this.clientData.datosIndice.patronos = [];
    this.clientData.datosIndice.isMoreChiefs = false;
    this.clientData.datosIndice.position = null;
    if(!this.clienteserviceParam.rolABFlag){
      this.codigoinput.nativeElement.blur();
      this.nombreinput.nativeElement.blur();
    }
    this.listPatronos = new Map();
    const item = {
      numeropatrono: this.patronesForm.get('codigoPatrono').value === ''
        ? 0 : this.patronesForm.get('codigoPatrono').value,
      descripcionpatrono: this.patronesForm.get('nombrePatrono').value === ''
        ? ' ' : this.clienteserviceParam.getCleanedString(this.patronesForm.get('nombrePatrono').value).toUpperCase(),
    };
    if (this.precalificationData.segmento === 'PV') {
      item.descripcionpatrono=' '
    }
    
    this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
    this.clienteserviceParam.consultaPatrono( item).then(datos => {
        this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
        if (datos.patrono.length === 1) {
          this.patronoSelected = datos.patrono[0];
          if (this.precalificationData.segmento === 'E'
            && datos.patrono[0].indicaIndice === 'S'
            && (this.clientData.datosIndice.clienteDatosIndice.length === 0
              || this.clienteserviceParam.manualEntry === true)) {
            this.showNotification('Alerta', 'La persona a evaluar no corresponde a un empleado del patrono ingresado');
          } else if (this.precalificationData.segmento === 'E'
            && datos.patrono[0].descripcionSegmentoPatrono === 'PRIVADAS'
            || this.precalificationData.segmento === 'P'
            && datos.patrono[0].descripcionSegmentoPatrono === 'ESTADO Y DESCENTRALIZADAS'
            || this.precalificationData.segmento === 'P'
            && datos.patrono[0].descripcionSegmentoPatrono === 'PREFERENTES'
            || this.precalificationData.segmento === 'P'
            && datos.patrono[0].descripcionSegmentoPatrono === 'DESCENTRALIZADO') {
            this.patronesForm.get('codigoPatrono').setValue('');
            this.patronesForm.get('nombrePatrono').setValue('');
            this.patronesForm.get('codigoCliente').setValue('');
            this.patronesForm.get('estado').setValue('');
            this.patronesForm.get('categoriariesgo').setValue('');
            this.patronesForm.get('categoriagasto').setValue('');
            this.showNotification('¡Alerta!', 'El patrono ingresado no corresponde al segmento seleccionado.');
          } else {
            if (datos.patrono[0].estado === 'A') {
              if (this.precalificationData.segmento === 'E' && datos.patrono[0].indicaIndice === 'N') {
                this.showNotification('Alerta', 'El patrono ingresado no posee índices');
              }
              this.patronesForm.get('codigoPatrono').setValue(datos.patrono[0].numeroPatrono);
              this.patronesForm.get('nombrePatrono').setValue(datos.patrono[0].nombrePatrono);
              this.patronesForm.get('codigoCliente').setValue(datos.patrono[0].codigoCliente);
              this.patronesForm.get('estado').setValue('A (Activo)');
              this.patronesForm.get('categoriariesgo').setValue(datos.patrono[0].categoriaRiesgo);
              this.patronesForm.get('categoriagasto').setValue(datos.patrono[0].clasificacionGasto);
            } else if (datos.patrono[0].estado === 'B') {
              this.patronesForm.get('codigoPatrono').setValue('');
              this.patronesForm.get('nombrePatrono').setValue('');
              this.patronesForm.get('codigoCliente').setValue('');
              this.patronesForm.get('estado').setValue('');
              this.patronesForm.get('categoriariesgo').setValue('');
              this.patronesForm.get('categoriagasto').setValue('');
              this.showNotification('¡Alerta!', 'El patrono ingresado se encuentra Bloqueado.');
            } else if (datos.patrono[0].estado === 'I') {
              this.patronesForm.get('codigoPatrono').setValue('');
              this.patronesForm.get('nombrePatrono').setValue('');
              this.patronesForm.get('codigoCliente').setValue('');
              this.patronesForm.get('estado').setValue('');
              this.patronesForm.get('categoriariesgo').setValue('');
              this.patronesForm.get('categoriagasto').setValue('');
              this.showNotification('¡Alerta!', 'El patrono ingresado se encuentra Inactivo.');
            } else if (datos.patrono[0].estado === 'C') {
              this.patronesForm.get('codigoPatrono').setValue('');
              this.patronesForm.get('nombrePatrono').setValue('');
              this.patronesForm.get('codigoCliente').setValue('');
              this.patronesForm.get('estado').setValue('');
              this.patronesForm.get('categoriariesgo').setValue('');
              this.patronesForm.get('categoriagasto').setValue('');
              this.showNotification('¡Alerta!', 'El patrono ingresado se encuentra Cerrado.');
            }
          }
          if (this.precalificationData.segmento != 'PV') {
            this.allowPatron(datos.patrono[0].numeroPatrono, datos.patrono[0].nombrePatrono);
          }
          
        } else if (datos.patrono.length === 0) {
          this.showNotification('Alerta', 'No se encontraron patronos que coincidan con el nombre ingresado');
        } else {
          this.dataPatronos = datos.patrono;
          datos.patrono.forEach((element: any) => {
            this.listPatronos.set(element.numeroPatrono, element.nombrePatrono);
          });
          this.showPatronosAlert();
        }
      }).catch(error => {
        this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
        this.showNotification('Un error Ha ocurrido', 'Por favor inténtelo de nuevo');
      });
  }
  goToIngresos() {
    this.submitAttempt = true;
    this.patronesForm.markAllAsTouched();
    if (!this.patronesForm.valid &&!this.clienteserviceParam.rolABFlag) {
    } else {
      if (this.patronesForm.get('reglon').value === '0' && ((this.clienteserviceParam.flowType === 'DEBTOR'&&this.clienteserviceParam.datosPrecalificacion.segmento === 'E')||(this.clienteserviceParam.flowType === 'CODEBTOR'&&this.clienteserviceParam.datosPrecalificacionCodeudor.segmento === 'E'))) {
        this.showNotification('Alerta', 'Debe ingresar un número de reglon para continuar.');
      } else if (!this.validateFechaIngreso(this.patronesForm.get('fechaingreso').value)) {
        this.showNotification('Alerta', 'La fecha de ingreso empleo actual debe ser menor a la fecha actual.');
      } else if (this.patronesForm.get('empleoanterior').value === 'S') {
        if (!this.clienteserviceParam.dateIsBefore(
          this.patronesForm.get('fechafinempleoanterior').value,
          this.patronesForm.get('fechaingreso').value,
        )) {
          this.showNotification('Alerta', 'La fecha empleo anterior fin debe ser menor a la fecha ingreso actual.');
          // tslint:disable-next-line:max-line-length
        } else if (!this.clienteserviceParam.dateIsBefore(
          this.patronesForm.get('fechainicioempleoanterior').value,
          this.patronesForm.get('fechafinempleoanterior').value)
        ) {
          this.showNotification('Alerta', 'La fecha empleo anterior inicio debe ser menor a la fecha empleo anterior fin.');
        } else {
          if (this.patronoSelected.reglon == null || this.patronoSelected.reglon == '') {
            this.patronoSelected.renglon=this.patronesForm.get('reglon').value
          }
          if (this.clienteserviceParam.flowType === 'DEBTOR') {
            this.clienteserviceParam.datosPrecalificacion.datosPatrono = this.patronesForm.getRawValue();
            this.clienteserviceParam.datosPrecalificacion.patronoSelected = this.patronoSelected;
          } else {
            this.clienteserviceParam.datosPrecalificacionCodeudor.datosPatrono = this.patronesForm.getRawValue();
            this.clienteserviceParam.datosPrecalificacionCodeudor.patronoSelected = this.patronoSelected;
          }
          this.goToMontoYplazo()
        }
      } else {
        if (this.patronoSelected.reglon == null || this.patronoSelected.reglon == '') {
          this.patronoSelected.renglon=this.patronesForm.get('reglon').value
        }
        if (this.clienteserviceParam.flowType === 'DEBTOR') {
          this.clienteserviceParam.datosPrecalificacion.datosPatrono = this.patronesForm.getRawValue();
          this.clienteserviceParam.datosPrecalificacion.patronoSelected = this.patronoSelected;
          if (!this.clienteserviceParam.datosPrecalificacion.patronoSelected) {
            this.clienteserviceParam.datosPrecalificacion.patronoSelected = this.patronoSelected;
          }
        } else {
          this.clienteserviceParam.datosPrecalificacionCodeudor.datosPatrono = this.patronesForm.getRawValue();
          this.clienteserviceParam.datosPrecalificacionCodeudor.patronoSelected = this.patronoSelected;
          if (!this.precalificationData.patronoSelected) {
            this.clienteserviceParam.datosPrecalificacionCodeudor.patronoSelected = this.patronoSelected;
          }
        }
        this.goToMontoYplazo()
      }
    }
  }

  solicitudOfertaTc() {
    this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
    this.clienteserviceParam.solicitarOferta().then(result=>{
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
      if(result=='A'){
        this.selecttab.emit(18)
      }else{
        this.selecttab.emit(11)
      }
    }).catch(error=>{
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
      this.showNotification('Alerta', 'Un error ha ocurrido, intente de nuevo.')
    })
  }

  goBack() {
    if (this.clienteserviceParam.flowType === 'DEBTOR') {
      this.clienteserviceParam.datosPrecalificacion.datosPatrono = null;
      this.clienteserviceParam.datosPrecalificacion.patronoSelected = null;
    } else {
      this.clienteserviceParam.datosPrecalificacionCodeudor.datosPatrono = null;
      this.clienteserviceParam.datosPrecalificacionCodeudor.patronoSelected = null;
    }
    this.clienteserviceParam.manualEntry = false;
    this.clienteserviceParam.isLoadIndex = false;
    this.selecttab.emit(14);
  }
  showPatronosAlert() {
    swal.fire({
      title: 'Patronos',
      input: 'select',
      inputOptions: this.listPatronos,
      inputPlaceholder: 'Seleccione un patrono',
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'selectswal',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      heightAuto: false,
      confirmButtonText: 'Continuar'
    }).then(result => {
      if (result.isConfirmed) {
        const aux = this.dataPatronos.find(i => i.numeroPatrono === result.value);
        if (this.precalificationData.segmento === 'E'
            && aux.descripcionSegmentoPatrono === 'PRIVADAS'
              || this.precalificationData.segmento === 'P'
                && aux.descripcionSegmentoPatrono === 'ESTADO Y DESCENTRALIZADAS'
                  || this.precalificationData.segmento === 'P'
                    && aux.descripcionSegmentoPatrono === 'PREFERENTES'
                      || this.precalificationData.segmento === 'P'
                        && aux.descripcionSegmentoPatrono === 'DESCENTRALIZADO') {
          this.patronesForm.get('codigoPatrono').setValue('');
          this.patronesForm.get('nombrePatrono').setValue('');
          this.showNotification('¡Alerta!', 'El patrono ingresado no corresponde al segmento seleccionado.');
        } else {
          if (this.precalificationData.segmento === 'E'
            && aux.indicaIndice === 'S'
            && (this.clientData.datosIndice.clienteDatosIndice.length === 0
              || this.clienteserviceParam.manualEntry === true)) {
            this.showNotification('Alerta', 'La persona a evaluar no corresponde a un empleado del patrono ingresado.');
          } else {
            if (aux.estado === 'A') {
              if (this.precalificationData.segmento === 'E'
                && aux.indicaIndice === 'N') {
                this.showNotification('Alerta', 'El patrono ingresado no posee índices');
              }
              this.patronoSelected = aux;
              this.patronesForm.get('codigoPatrono').setValue(aux.numeroPatrono);
              this.patronesForm.get('nombrePatrono').setValue(aux.nombrePatrono);
              this.patronesForm.get('codigoCliente').setValue(aux.codigoCliente);
              this.patronesForm.get('estado').setValue('A (Activo)');
              this.patronesForm.get('categoriariesgo').setValue(aux.categoriaRiesgo);
              this.patronesForm.get('categoriagasto').setValue(aux.clasificacionGasto);
            } else if (aux.estado === 'B') {
              this.patronesForm.get('codigoPatrono').setValue('');
              this.patronesForm.get('nombrePatrono').setValue('');
              this.patronesForm.get('codigoCliente').setValue('');
              this.patronesForm.get('estado').setValue('');
              this.patronesForm.get('categoriariesgo').setValue('');
              this.patronesForm.get('categoriagasto').setValue('');
              this.showNotification('¡Alerta!', 'El patrono ingresado se encuentra Bloqueado.');
            } else if (aux.estado === 'I') {
              this.patronesForm.get('codigoPatrono').setValue('');
              this.patronesForm.get('nombrePatrono').setValue('');
              this.patronesForm.get('codigoCliente').setValue('');
              this.patronesForm.get('estado').setValue('');
              this.patronesForm.get('categoriariesgo').setValue('');
              this.patronesForm.get('categoriagasto').setValue('');
              this.showNotification('¡Alerta!', 'El patrono ingresado se encuentra Inactivo.');
            } else if (aux.estado === 'C') {
              this.patronesForm.get('codigoPatrono').setValue('');
              this.patronesForm.get('nombrePatrono').setValue('');
              this.patronesForm.get('codigoCliente').setValue('');
              this.patronesForm.get('estado').setValue('');
              this.patronesForm.get('categoriariesgo').setValue('');
              this.patronesForm.get('categoriagasto').setValue('');
              this.showNotification('¡Alerta!', 'El patrono ingresado se encuentra Cerrado.');
            }
          }
        }
        this.allowPatron(aux.numeroPatrono, aux.nombrePatrono);
      }
    });
  }
  showNotification(title, message) {
    swal.fire({
      title,
      text: message,
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      confirmButtonText: 'Continuar'
    }).then(result => {

    });
  }
  showNotificationSegmento(title, message) {
    swal.fire({
      title,
      text: message,
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      confirmButtonText: 'Continuar'
    }).then(result => {
      this.selecttab.emit(14);
    });
  }
  changeEmpleoAnterior() {
    if (this.patronesForm.get('empleoanterior').value === 'S') {
      this.patronesForm.controls.fechainicioempleoanterior.setValidators(Validators.compose([
        Validators.pattern(/^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/\-](20|19)\d{2}$/),
      ]));
      this.patronesForm.controls.fechainicioempleoanterior.updateValueAndValidity();
      this.patronesForm.controls.fechafinempleoanterior.setValidators(Validators.compose([
        Validators.pattern(/^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/\-](20|19)\d{2}$/),
      ]));
      this.patronesForm.controls.fechafinempleoanterior.updateValueAndValidity();
    } else {
      this.patronesForm.controls.fechainicioempleoanterior.clearValidators();
      this.patronesForm.controls.fechainicioempleoanterior.updateValueAndValidity();
      this.patronesForm.controls.fechafinempleoanterior.clearValidators();
      this.patronesForm.controls.fechafinempleoanterior.updateValueAndValidity();
    }
  }

  setManualEntry(value: any) {
    if (value) {
      this.clienteserviceParam.manualEntry = true;
      this.clientData.datosIndice.patronos = [];
      this.patronos = [];
      this.clientData.datosIndice.isMoreChiefs = false;
      this.patronesForm.get('reglon').enable();
      this.patronesForm.get('codigoPatrono').enable();
      this.patronesForm.get('nombrePatrono').enable();
      this.patronesForm.get('codigoEmpleado').enable();
      this.patronesForm.get('fechaingreso').enable();
      this.patronesForm.reset();
      this.patronesForm.get('reglon').setValue('0');
      this.patronesForm.get('empleoanterior').setValue('N');
      this.clientData.existeEmpleadoGobierno = 'N';
      if (this.clienteserviceParam.flowType === 'DEBTOR') {
       this.clienteserviceParam.datosPrecalificacion.ingresosydeducciones = null;
      } else {
        this.clienteserviceParam.datosPrecalificacionCodeudor.ingresosydeducciones = null;
      }
    } else {
      this.clienteserviceParam.manualEntry = false;
      this.clientData.existeEmpleadoGobierno = 'S';
      this.autocompleteDataPatrono();
    }
  }

  autocompleteDataPatrono() {
      this.clientData.datosIndice.patronos = [];
      this.clientData.datosIndice.isMoreChiefs = false;
      if (this.clienteserviceParam.manualEntry || (this.precalificationData.datosPatrono != null
        && this.clientData.datosIndice.clienteDatosIndice.length === 0)) {
        this.patronesForm.setValue(this.precalificationData.datosPatrono);
        this.patronoSelected = this.precalificationData.patronoSelected;
      } else {
        if (this.precalificationData.datosPatrono != null
          && this.clientData.datosIndice.clienteDatosIndice[0].patrono[0].numeroPatrono === '46001') {
          this.patronesForm.setValue(this.precalificationData.datosPatrono);
          this.patronesForm.get('reglon').disable();
          this.patronesForm.get('codigoPatrono').disable();
          this.patronesForm.get('nombrePatrono').disable();
          if (this.clientData.datosIndice.clienteDatosIndice[0].identificadorEmpleado !== '') {
            this.patronesForm.get('codigoEmpleado').disable();
          }
        }
        if (this.precalificationData.datosPatrono != null) {
          this.patronoSelected = this.precalificationData.patronoSelected;
        }
        if (this.clientData.cliente.existeEmpleadoGobierno === 'S') {
          if (this.precalificationData.segmento === 'E'
            && this.clientData.datosIndice.clienteDatosIndice.length > 0) {
            this.clienteserviceParam.isLoadIndex = true;
            const clientIndexData  = this.clientData.datosIndice.clienteDatosIndice;

            if (this.patronos.length === 0) {
              clientIndexData.forEach((data, index) => {
                if (data.patrono.length > 0) {
                  data.patrono[0].renglon = data.reglonPresupuestario;
                  data.patrono[0].identificadorEmpleado = data.identificadorEmpleado;
                  data.patrono[0].fechaIngreso = data.fechaIngreso;
                  data.patrono[0].position = index;
                  data.patrono[0].selected = false;
                  this.patronos.push(data.patrono[0]);
                }
              });
            }

            if (this.patronos.length > 1) {
              this.clientData.datosIndice.isMoreChiefs = true;
              this.clientData.datosIndice.patronos = this.patronos;
            }

            const position = this.clientData.datosIndice.position
              ? this.clientData.datosIndice.position : 0;

            if (this.clientData.datosIndice.clienteDatosIndice[position].patrono[0].estado === 'A') {
              this.autocompleteE = true;
              this.patronoSelected = this.clientData.datosIndice.clienteDatosIndice[position].patrono[0];
              this.patronesForm.get('codigoPatrono').setValue(
                this.clientData.datosIndice.clienteDatosIndice[position].patrono[0].numeroPatrono,
              );
              this.patronesForm.get('nombrePatrono').setValue(
                this.clientData.datosIndice.clienteDatosIndice[position].patrono[0].nombrePatrono,
              );
              this.patronesForm.get('codigoCliente').setValue(
                this.clientData.datosIndice.clienteDatosIndice[position].patrono[0].codigoCliente,
              );
              this.patronesForm.get('estado').setValue('A (Activo)');
              this.patronesForm.get('categoriariesgo').setValue(
                this.clientData.datosIndice.clienteDatosIndice[position].patrono[0].categoriaRiesgo,
              );
              this.patronesForm.get('categoriagasto').setValue(
                this.clientData.datosIndice.clienteDatosIndice[position].patrono[0].clasificacionGasto,
              );
              this.patronesForm.get('codigoPatrono').disable();
              this.patronesForm.get('nombrePatrono').disable();
              if (this.clientData.datosIndice.clienteDatosIndice[position].reglonPresupuestario !== '') {
                this.patronesForm.get('reglon').setValue(
                  this.clientData.datosIndice.clienteDatosIndice[position].reglonPresupuestario,
                );
                this.patronesForm.get('reglon').disable();
              } else if (
                this.clientData.datosIndice.clienteDatosIndice[position].patrono[0].numeroPatrono === '46001'
              ) {
                this.patronesForm.get('reglon').setValue('11');
                this.patronesForm.get('reglon').disable();
              }
              if (this.clientData.datosIndice.clienteDatosIndice[position].fechaIngreso !== '') {
                this.patronesForm.get('fechaingreso').setValue(
                  this.clienteserviceParam.getDateFormat(this.clientData.datosIndice.clienteDatosIndice[position].fechaIngreso,
                  ));
                this.patronesForm.get('fechaingreso').disable();
              } else {
                this.patronesForm.get('fechaingreso').enable();
              }

              if (this.clientData.datosIndice.clienteDatosIndice[position].identificadorEmpleado !== '') {
                this.patronesForm.get('codigoEmpleado').setValue(
                  this.clientData.datosIndice.clienteDatosIndice[position].identificadorEmpleado,
                );
                this.patronesForm.get('codigoEmpleado').disable();
              }

            } else if (this.clientData.datosIndice.clienteDatosIndice[position].patrono[0].estado === 'B') {
              this.showNotification('¡Alerta!', 'El patrono ingresado se encuentra Bloqueado.');
            } else if (this.clientData.datosIndice.clienteDatosIndice[position].patrono[0].estado === 'I') {
              this.showNotification('¡Alerta!', 'El patrono ingresado se encuentra Inactivo.');
            } else if (this.clientData.datosIndice.clienteDatosIndice[position].patrono[0].estado === 'C') {
              this.showNotification('¡Alerta!', 'El patrono ingresado se encuentra Cerrado.');
            }

            if (this.patronos.length > 1) {
              this.patronesForm.controls.codigoPatronoSelected.setValue(this.patronos[0]);
            }
          }
        }
      }
      if (this.patronos.length === 2 && this.clientData.datosIndice.isBack) {
        if (this.patronos[0].nombrePatrono === this.patronos[1].nombrePatrono) {
          const chiefsReplace = [];
          const chief = this.patronos.find(item => item.renglon === this.patronesForm.controls.reglon.value);
          this.patronos.forEach(item => {
            if (chief) {
              if (chief.renglon === item.renglon) {
                chiefsReplace.unshift(item);
              } else {
                chiefsReplace.push(item);
              }
            }
          });
          this.patronos = chiefsReplace;
        }
      }
  }
  validateFechaIngreso(date) {
    const fechaactual = this.clienteserviceParam.getcurrentdate();
    return this.clienteserviceParam.dateIsBefore(date, fechaactual);
  }
  validateFecaIngresoOtroEmpleo(date) {
    const valid = true;

  }
  onFocus() {
    this.patronesForm.get('codigoPatrono').setValue('');
    this.patronesForm.get('nombrePatrono').setValue('');
  }

  changeChief(data) {
    const chief = this.patronesForm.controls.codigoPatronoSelected.value;
    this.mostrarFecha = !chief.fechaIngreso;
    this.clientData.datosIndice.position = chief.position;
    this.patronesForm.controls.codigoPatrono.setValue(chief.numeroPatrono);
    this.patronesForm.controls.nombrePatrono.setValue(chief.nombrePatrono);
    this.patronesForm.controls.codigoCliente.setValue(chief.codigoCliente);
    this.patronesForm.controls.estado.setValue(
      chief.estado === 'A'
        ? 'A (Activo)' : chief.estado,
    );

    this.patronesForm.controls.categoriariesgo.setValue(chief.categoriaRiesgo);
    this.patronesForm.controls.categoriagasto.setValue(chief.categoriaGasto);
    this.patronesForm.controls.codigoEmpleado.setValue(chief.identificadorEmpleado);

    if (chief.fechaIngreso === '') {
      this.patronesForm.controls.fechaingreso.enable();
      this.patronesForm.controls.fechaingreso.setValue('');
    } else {
      this.patronesForm.controls.fechaingreso.setValue(
        this.clienteserviceParam.getDateFormat(chief.fechaIngreso),
      );
      this.patronesForm.controls.fechaingreso.disable();
    }

    if (chief.renglon !== '') {
      this.patronesForm.controls.reglon.setValue(chief.renglon);
      this.patronesForm.controls.reglon.disable();
    } else {
      this.patronesForm.controls.reglon.setValue('0');
      this.patronesForm.controls.reglon.enable();
    }

    if (this.patronesForm.controls.codigoPatrono.value === '46001') {
      this.patronesForm.controls.reglon.setValue('11');
      this.patronesForm.controls.reglon.disable();
    }
    this.patronoSelected = chief;
    const findChief = this.patronos.find(item => item.numeroPatrono === chief.numeroPatrono);
    if (findChief && this.clientData.datosIndice.patronos.length > 0) {
      this.patronos = [];
      this.clientData.datosIndice.patronos.forEach(item => {
        if (item.numeroPatrono === findChief.numeroPatrono) {
          this.patronos.unshift(item);
        } else {
          this.patronos.push(item);
        }
      });
      this.clientData.datosIndice.patronos = this.patronos;
    }
    this.autocompleteIngresos();
  }
  changeIngresos(element) {
    element.target.value = this.formatterDecimal.format(
      element.target.value.toString().replace(",", "")
    );
  }
  autocompleteIngresos() {
    this.ingresosydeducciones.bonificaciones = "0.00";
    this.ingresosydeducciones.comisiones = "0.00";
    this.ingresosydeducciones.otrosIngresos = "0.00";
    this.ingresosydeducciones.otrasDeducciones = "0.00";
    this.ingresosydeducciones.salarioBase = "0.00";
    this.ingresosydeducciones.salarioLiquidoBT = "0.00";
    this.ingresosydeducciones.cuotaBancoIndice = "0.00";
    this.ingresosydeducciones.judiciales = "0.00";
    const position = this.clientData.datosIndice.position
      ? this.clientData.datosIndice.position
      : 0;
    if (this.clientData.cliente.nombreCompleto != null) {
      if (
        this.precalificationData.ingresosydeducciones && this.precalificationData.segmento !== "E"
      ) {
        this.ingresosydeducciones =
          this.precalificationData.ingresosydeducciones;
        if (this.clientData.datosIndice.clienteDatosIndice.length > 0) {
          this.cargaindicesbool = true;
        }
      } else {
        this.ingresosydeducciones.salarioBase = "0.00";
        if (
          this.clientData.cliente.existeEmpleadoGobierno === "S" &&
          this.precalificationData.segmento === "E" &&
          !this.clienteserviceParam.manualEntry
        ) {
          if (this.clientData.datosIndice.clienteDatosIndice.length > 0) {
            this.patronesForm.get('salarioBase').setValue(this.clientData.datosIndice.clienteDatosIndice[position]
              .salarioNominal === ""
              ? "0.00"
              : this.clientData.datosIndice.clienteDatosIndice[position]
                  .salarioNominal)
            this.ingresosydeducciones.salarioLiquidoBT =
              this.clientData.datosIndice.clienteDatosIndice[position]
                .salarioLiquido === ""
                ? "0.00"
                : this.clientData.datosIndice.clienteDatosIndice[position]
                    .salarioLiquido;
            this.ingresosydeducciones.cuotaBancoIndice =
              this.clientData.datosIndice.clienteDatosIndice[position]
                .valorDescuentoCuotaBantrab === ""
                ? "0.00"
                : this.clientData.datosIndice.clienteDatosIndice[position]
                    .valorDescuentoCuotaBantrab;
            this.ingresosydeducciones.judiciales =
              this.clientData.datosIndice.clienteDatosIndice[position]
                .valorDescuentoJudicial === ""
                ? "0.00"
                : this.clientData.datosIndice.clienteDatosIndice[position]
                    .valorDescuentoJudicial;
            this.ingresosydeducciones.judiciales =
              +this.ingresosydeducciones.judiciales === 0
                ? "0.00"
                : this.ingresosydeducciones.judiciales;
            this.cargaindicesbool = true;
          }
        } else {
          this.ingresosydeducciones.salarioBase = "0.00";
        }
      }
    }
  }
  validateCustomer(isNewClient: any) {
    this.ngxUiLoaderService.startLoader("loader-global", "loadingDashboard");
    if(this.clienteserviceParam.rolVerificacionFlag){
      this.selecttab.emit(16);
    }else{
      this.clienteserviceParam
      .validateCustomerAcceptanceCriteria(isNewClient)
      .subscribe(
        (result) => {
          const data = result;
          // @ts-ignore
          if (data.codigo !== 2 && data.Respuesta !== null) {
            // @ts-ignore
            const acceptanceCriteria = data.Respuesta.criterioAcpetacion;
            if (acceptanceCriteria && acceptanceCriteria.length > 0) {
              const criteria = acceptanceCriteria.find(
                (item) => item.tipoParticipante === "DEUDOR"
              );
              if (criteria) {
                if (criteria.outCriterioValidacionPrecalificacionFlg === "N") {
                  this.ngxUiLoaderService.stopLoader(
                    "loader-global",
                    "loadingDashboard"
                  );
                  const message =
                    criteria.outCriterioValidacionPrecalificacionMsj;
                  const list = message.split("/ ");
                  if (list.length > 0) {
                    const title = `<strong>${list[0]}</strong>`;
                    let text = "";
                    list.forEach((item, index) => {
                      if (index !== 0) {
                        text = text + `<span>${item}</span><br>`;
                      }
                    });
                    if (this.clienteserviceParam.flowType === "DEBTOR") {
                      this.alertService.show(title, text).then();
                      this.selecttab.emit(0);
                    } 
                  }
                } else {
                  if(this.clienteserviceParam.rolABFlag){//si es flujo agentes bancarios
                    this.ngxUiLoaderService.stopLoader(
                      "loader-global",
                      "loadingDashboard"
                    );
                    this.selecttab.emit(20);
                  }else{
                    this.selecttab.emit(16); 
                  }
                }
              } else {
                this.showNotification(
                  "Alerta",
                  "Ha ocurrido un error, intente más tarde."
                );
              }
            } else {
              this.showNotification(
                "Alerta",
                "Ha ocurrido un error, intente más tarde."
              );
            }
          } else {
            this.showNotification(
              "Alerta",
              "Ha ocurrido un error, intente más tarde."
            );
            this.ngxUiLoaderService.stopLoader(
              "loader-global",
              "loadingDashboard"
            );
          }
        },
        (error) => {
          this.showNotification(
            "Alerta",
            "Ha ocurrido un error, intente más tarde."
          );
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
        }
      );
    }
  }
  goToMontoYplazo() {
    this.ingresosydeducciones.salarioBase=this.patronesForm.get('salarioBase').value
    if (
      this.ingresosydeducciones.salarioBase == null ||
      this.ingresosydeducciones.salarioBase === ""||
      this.ingresosydeducciones.salarioBase === 0 ||
      this.ingresosydeducciones.salarioBase === "0" ||
      this.ingresosydeducciones.salarioBase === "0.00"
    ) {
      this.showNotification("Alerta", "El salario debe ser mayor a cero.");
    } else {
      this.ingresosydeducciones.bonificaciones =
        this.ingresosydeducciones.bonificaciones !== null
          ? this.ingresosydeducciones.bonificaciones
          : "0";
      this.ingresosydeducciones.comisiones =
        this.ingresosydeducciones.comisiones !== null
          ? this.ingresosydeducciones.comisiones
          : "0";
      this.ingresosydeducciones.otrosIngresos =
        this.ingresosydeducciones.otrosIngresos !== null
          ? this.ingresosydeducciones.otrosIngresos
          : "0";
      this.ingresosydeducciones.igss =
        this.ingresosydeducciones.igss !== null
          ? this.ingresosydeducciones.igss
          : "0";
      this.ingresosydeducciones.isr =
        this.ingresosydeducciones.isr != null
          ? this.ingresosydeducciones.isr
          : "0";
      this.ingresosydeducciones.judiciales =
        this.ingresosydeducciones.judiciales !== null
          ? this.ingresosydeducciones.judiciales
          : "0";
      this.ingresosydeducciones.otrasDeducciones =
        this.ingresosydeducciones.otrasDeducciones !== null
          ? this.ingresosydeducciones.otrasDeducciones
          : "0";
      this.ingresosydeducciones.cuotaBancoIndice =
        this.ingresosydeducciones.cuotaBancoIndice !== null
          ? this.ingresosydeducciones.cuotaBancoIndice
          : "0";
      this.ingresosydeducciones.salarioLiquidoBT =
        this.ingresosydeducciones.salarioLiquidoBT !== null
          ? this.ingresosydeducciones.salarioLiquidoBT
          : "0";
      this.clienteserviceParam.setIngresosyDedudcciones(
        this.ingresosydeducciones
      );

      if (this.clienteserviceParam.tipoPrecalificacion === "tarjeta_credito") {
        this.solicitudOfertaTc();
      }
      else {
        this.validateCustomer(
          this.clientData.isNewExistClient
            ? this.clientData.isNewExistClient
            : false
        );
      }
    }
  }
}
